/* Sorti de la page le 19 aout 2026 : ce code est le meme pour toutes les
   pages, donc il appartient a un fichier que le navigateur garde en cache,
   pas au HTML qui est retelecharge a chaque visite.

   La garde ci-dessous existe parce qu'un fichier charge deux fois s'execute
   deux fois, ce qui doublerait les ecouteurs. */
if (!window.__fvCatalogPackJs) {
  window.__fvCatalogPackJs = true;
(function () {
  'use strict';

  var node = document.getElementById('fv-cat-data');
  if (!node) return;

  var CAT;
  try { CAT = JSON.parse(node.textContent); } catch (e) { return; }

  /* Les paliers, le format monetaire et les fonctions qui les manipulaient
     (U, SHIP, SHOWP, CUR, money, unit, nextRung, prevRung) ne servaient qu'a
     paint(). Ils sont partis avec lui. Le seul endroit du theme qui traduit
     un nombre de polos en prix est desormais snippets/fv-pack-meter.liquid,
     et c'est la raison d'etre de tout ce chantier : un chiffre calcule a deux
     endroits est un chiffre qui finit par differer. */

  /* ─── Etat ─── */
  var counts = {};   // product_id -> quantite au panier
  var total  = 0;    // nombre de polos du catalogue presents au panier

  /* ─── SA TAILLE ───────────────────────────────────────────────────────────
     Meme notion que sur la fiche produit, et lue au meme endroit : c'est la
     fiche qui possede la memoire de taille et qui l'expose sur window.FVSize.
     On ne relit pas la cle localStorage a la main: deux lectures de la meme
     cle sont deux definitions de « sa taille » qui finiront par differer.

     Une carte dont la taille memorisee n'existe pas dans ce polo, ou y est
     epuisee, retombe mot pour mot sur l'ancien comportement : le selecteur
     s'ouvre. La memoire ne peut donc jamais empecher un achat. */
  function mySize() {
    try { return (window.FVSize && window.FVSize.get()) || null; } catch (e) { return null; }
  }
  function mineOf(data) {
    var want = mySize();
    if (!want) return null;
    for (var i = 0; i < data.v.length; i++) {
      if (data.v[i].a && data.v[i].t === want) return data.v[i];
    }
    return null;
  }

  /* Tous les identifiants produit du catalogue : ce qui n'est pas la-dedans
     (une carte cadeau, un accessoire) ne doit pas gonfler le compteur de polos
     ni faire croire au client qu'il a atteint un palier. */
  var known = {};
  Object.keys(CAT).forEach(function (h) { known[CAT[h].pid] = true; });

  /* Les vignettes annoncent aussi leur produit. La table s'arrete a la
     premiere page ; les cartes, non. Sans cette seconde source, un polo
     arrive par le defilement infini serait au panier sans jamais compter
     dans le sac. */
  function learn(root) {
    (root || document).querySelectorAll('li[data-fv-pid]').forEach(function (li) {
      var p = parseInt(li.getAttribute('data-fv-pid'), 10);
      if (p) known[p] = true;
    });
  }
  learn(document);
  document.addEventListener('fv:grid-appended', function () { learn(document); });

  /* ─── La barre ─── */
  /* paint() vivait ici : cent lignes qui recalculaient le palier, le prix
     unitaire, la phrase de relance et le pourcentage de la jauge. C'est
     exactement ce que fait fv-pack-meter, en lisant le meme panier. Deux
     calculs pour un seul chiffre, c'est un chiffre qui finit par differer
     d'une page a l'autre, et le catalogue disait deja « both drop to $35 »
     la ou la fiche produit disait « Add 1 more polo → $35 each ».

     Il ne reste ici que ce que fv-pack-meter ne sait pas faire : le compteur
     du sac dans l'en-tete, et la pastille de quantite sur chaque carte, qui
     demandent le detail produit par produit. */

  function readCart(cart) {
    counts = {}; total = 0;
    (cart.items || []).forEach(function (it) {
      if (!known[it.product_id]) return;
      /* Compte par VARIANTE, pas par produit : une carte du catalogue est
         desormais une couleur, et c'est cette couleur-la qu'elle doit
         reconnaitre au panier. `total` reste un compte de polos, toutes
         couleurs confondues: c'est ce que mesurent les paliers. */
      counts[it.variant_id] = (counts[it.variant_id] || 0) + it.quantity;
      total += it.quantity;
    });
    document.querySelectorAll('.fv-h-bag-count').forEach(function (el) {
      el.textContent = cart.item_count;
    });
    /* La barre se met a jour toute seule : fv-pack-meter ecoute le meme
       evenement « cart:update ». On ne lui pousse rien. */
    badges();
  }

  function refresh() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(readCart)
      .catch(function () {});
  }

  /* ─── Les cartes ─── */
  function handleOf(card) {
    var a = card.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* La couleur que CETTE carte montre. Elle est deja ecrite sous le titre,
     c'est la ligne que le client lit. La relire ici plutot que de la deduire
     du lien evite d'avoir deux idees de la couleur d'une carte : celle qui
     s'affiche et celle qu'on ajoute au panier. */
  function colourOf(card) {
    var el = card.querySelector('.fv-card-color');
    return el ? el.textContent.replace(/\s+/g, ' ').trim() : '';
  }

  /* Ce qu'une carte a le droit d'ajouter : son polo, mais reduit a sa seule
     couleur. Une carte sans couleur annoncee (les autres sections du site)
     retombe sur la couleur par defaut, c'est-a-dire sur l'ancien comportement.
     Un repli sur la liste entiere serait pire que l'erreur qu'on corrige : le
     selecteur afficherait « S M L S M L » sans dire laquelle est laquelle. */
  function viewOf(card) {
    var h = handleOf(card);

    /* La vignette porte ses propres tailles quand la grille du catalogue les
       lui a donnees. On les prefere a la table : la table est batie sur la
       premiere page, et une vignette ramenee par le defilement infini n'y
       figure pas. Sans cela, le dix-septieme polo n'aurait aucun bouton. */
    var li = card.closest('li[data-fv-sz]');
    if (li) {
      try {
        var own = JSON.parse(li.getAttribute('data-fv-sz'));
        if (own && own.length) {
          return { h: h, pid: parseInt(li.getAttribute('data-fv-pid'), 10) || 0, v: own };
        }
      } catch (e) {}
    }

    if (!h || !CAT[h]) return null;
    var d = CAT[h];
    var want = colourOf(card) || d.d || '';
    var v = d.v;
    if (want) {
      var f = v.filter(function (x) { return x.c === want; });
      if (f.length) v = f;
    }
    return { h: h, pid: d.pid, v: v };
  }

  /* ══════════════════════════════════════════════════════════════════
     LA QUANTITE EST DANS LE BOUTON — 15 septembre 2026
     ══════════════════════════════════════════════════════════════════
     Signale par Jeremie, capture d'iPhone a l'appui: la pastille de quantite
     vivait dans le coin HAUT GAUCHE de la photo, exactement la ou se pose le
     badge de remise. Les deux se superposaient, et le chiffre mangeait le
     signe moins de « -20 % ».

     Son arbitrage: le chiffre remplace la coche dans le bouton d'ajout. C'est
     mieux que de deplacer la pastille, et pas seulement parce que ca libere le
     coin. La coche disait « c'est au panier » sans dire combien; le chiffre
     dit les deux, au meme endroit, et il est deja vert. Un signe de moins, une
     information de plus.

     ⚠️ La pastille n'est plus creee ni stylee. Ne pas la remettre: elle
     retomberait sur le badge de remise. */
  function badges() {
    document.querySelectorAll('.card-wrapper').forEach(function (card) {
      var view = card.fvView || viewOf(card);
      if (!view) return;
      /* On compte les variantes de CETTE carte, pas celles du polo. Compter
         par produit ferait apparaitre le meme « 1 » sur les quatorze cartes du
         meme polo, dont treize couleurs que le client n'a jamais mises au
         panier. */
      var n = 0;
      for (var i = 0; i < view.v.length; i++) n += counts[view.v[i].id] || 0;
      var c = String(n);

      /* Le bouton suit le panier, comme la pastille. Sans ca, retirer le polo
         depuis le tiroir laissait une coche verte sur une carte qui n'est plus
         au panier, et un ajout depuis une AUTRE carte du meme polo ne mettait
         pas celle-ci a jour.
         Les trois etats transitoires ont la priorite : on ne repeint pas un
         bouton en train de dire « × », « ✓ » ou « ! ».
         On n'ecrit QUE si l'etat change vraiment : reecrire le meme texte
         remplace le noeud, reveille l'observateur de mutations et relance
         badges() en boucle. C'est le meme piege que pour la pastille. */
      var b = card.querySelector('.fv-cat-add');
      if (!b || b.disabled || !b.fvSay) return;
      if (b.classList.contains('is-open') || b.classList.contains('is-done')
          || b.classList.contains('is-fail')) return;
      var dedans = c !== '0';
      /* ⚠️ On compare aussi le TEXTE. Avec la coche, deux etats suffisaient et
         tester la classe suffisait. Avec le chiffre, passer de 1 a 2 laisse
         `is-in` inchangee: sortir ici figerait le bouton sur « 1 ». */
      if (b.classList.contains('is-in') === dedans && b.textContent === (dedans ? c : '+')) return;
      b.classList.toggle('is-in', dedans);
      b.fvSay(dedans ? c : '+',
        dedans ? b.fvTitle + ' \u00d7 ' + c + ' in your bag, tap to add another size'
               : 'Choose a size for ' + b.fvTitle);
    });
  }

  function build(card) {
    if (card.dataset.fvCat) return;
    var view = viewOf(card);
    if (!view) return;
    var h = view.h;
    /* Dawn pose deux .card__information par carte. Seule celle qui contient le
       prix est la vraie ; l'autre habille le survol de la photo. querySelector
       renverrait la mauvaise, celle du survol venant en premier dans le DOM. */
    var info = null;
    var all = card.querySelectorAll('.card__content > .card__information');
    for (var i = 0; i < all.length; i++) {
      if (all[i].querySelector('.card-information')) { info = all[i]; break; }
    }
    if (!info) info = all[all.length - 1];
    if (!info) return;
    card.dataset.fvCat = h;
    card.fvView = view;

    var data = view;
    var live = data.v.filter(function (v) { return v.a; });

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'fv-cat-add';
    info.appendChild(btn);

    /* Le bouton ne porte plus qu'un signe. Un glyphe ne se lit pas tout seul,
       « + » s'annonce « plus » a la synthese vocale, ce qui ne veut rien dire.
       Le nom du produit est donc pousse dans aria-label, et chaque etat le
       remet a jour : ce que l'oeil comprend du dessin, l'oreille doit
       l'entendre en toutes lettres. */
    var title = ((card.querySelector('.card__heading') || {}).textContent || 'this polo')
      .replace(/\s+/g, ' ').trim();
    function say(glyph, label) {
      btn.textContent = glyph;
      btn.setAttribute('aria-label', label);
    }
    btn.fvSay = say;
    btn.fvTitle = title;

    /* La taille du client sur CE polo, ou null. Recalculee a chaque annonce. */
    var mine = mineOf(data);

    /* Le bouton NOMME la taille des qu'il y en a une : « +L » et non « + ».
       Un « + » qui ajoute du L en un geste serait un bouton muet, le client
       doit lire ce qu'il declenche AVANT de le declencher, pas le decouvrir
       dans le panier. Sans taille en memoire, rien ne change : « + » ouvre le
       selecteur comme avant. */
    /* Le bouton ne montre qu'un signe plus, jamais la taille.

       Il affichait « +XL » quand une taille etait deja connue. Deux defauts:
       le bouton changeait de largeur d'une carte a l'autre selon la longueur
       du libelle, et la taille se lisait deux fois, dans le bouton et dans la
       rangee qui s'ouvre sur la photo. Un bouton d'ajout rapide dit ce qu'il
       fait, pas ce qu'on a choisi ailleurs.

       La taille memorisee n'est pas perdue pour autant: elle reste dans
       l'intitule pour les lecteurs d'ecran, elle reste marquee d'un trait
       plein dans la rangee des tailles, et un clic ajoute toujours
       directement dans cette taille sans rien demander. */
    /* Combien d'exemplaires de CETTE carte sont au panier. Meme calcul que
       badges(), sur les variantes de la carte et non du produit. */
    function auPanier() {
      var vv = (card.fvView || view).v, n = 0;
      for (var i = 0; i < vv.length; i++) n += counts[vv[i].id] || 0;
      return n;
    }
    btn.fvAuPanier = auPanier;

    function idle() {
      /* Reglage de Jeremie le 2026-09-03 : le vert ne s'efface plus.
         Il valait 1400 ms, puis le bouton redevenait un « + » jaune et rien
         ne disait plus que le polo etait au panier, sauf la pastille de
         quantite a l'autre coin. Desormais l'etat de repos DEPEND du panier :
         coche verte tant que la carte y est, « + » jaune sinon. C'est un etat,
         plus une animation, donc il survit au rechargement de la page.
         Le bouton reste cliquable : la rangee de tailles s'ouvre comme avant,
         c'est ce qui permet d'en ajouter un deuxieme. */
      var q = auPanier();
      if (q > 0) {
        btn.classList.add('is-in');
        say(String(q), title + ' \u00d7 ' + q + ' in your bag, tap to add another size');
      } else {
        btn.classList.remove('is-in');
        /* L'intitule pour les lecteurs d'ecran ne promet plus une taille non
           plus: depuis le 24 aout le « + » ouvre la rangee, il n'ajoute rien. */
        say('+', 'Choose a size for ' + title);
      }
      btn.classList.remove('fv-has-sz', 'fv-sz-long');
      var w = btn.closest('.card-wrapper');
      if (w) w.classList.remove('fv-cat-choix');
    }
    btn.fvIdle = idle;

    if (!live.length) { say('+', title + ', sold out'); btn.disabled = true; }
    else { idle(); }

    var row = document.createElement('div');
    row.className = 'fv-cat-sz';
    var chips = {};
    data.v.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.textContent = v.t;
      b.setAttribute('aria-label', 'Add ' + title + ' in size ' + v.t);
      if (!v.a) b.disabled = true;
      b.addEventListener('click', function () {
        /* Choisir ici vaut dire sa taille, exactement comme une pastille de
           fiche produit : c'est un geste explicite sur une taille precise. */
        try { if (window.FVSize) window.FVSize.set(v.t); } catch (e) {}
        add(v.id, btn, row, b);
      });
      chips[v.t] = b;
      row.appendChild(b);
    });

    /* Sa taille reste marquee dans le selecteur, pour les fois ou il s'ouvre
       quand meme: taille epuisee dans ce polo, ou changement d'avis. Un trait
       plein et non un fond vert : le vert est la couleur du geste accompli. */
    function syncMine() {
      mine = mineOf(data);
      Object.keys(chips).forEach(function (t) {
        chips[t].classList.toggle('is-mine', !!mine && t === mine.t);
      });
      if (!btn.disabled &&
          !btn.classList.contains('is-done') &&
          !btn.classList.contains('is-fail') &&
          !btn.classList.contains('is-open')) idle();
    }
    btn.fvSyncMine = syncMine;
    syncMine();
    /* Sur la photo, pas sous le texte: voir le commentaire de.fv-cat-sz.
       Si Dawn changeait de balisage et que .card__inner disparaissait, on
       retombe sous le bloc d'information : mieux vaut mal place que perdu. */
    var inner = card.querySelector('.card__inner');
    (inner || info).appendChild(row);

    btn.addEventListener('click', function () {
      /* ── LE « + » DEMANDE TOUJOURS LA TAILLE, 24 aout 2026 ──

         Il ajoutait directement quand une taille etait en memoire. Le client
         cliquait « + » et se retrouvait avec un L au panier sans l'avoir
         choisi sur CE polo-la. Deux problemes: la taille memorisee vient d'un
         autre modele, dont la coupe n'est pas forcement la meme, et surtout un
         bouton qui engage un achat precis sans rien montrer prend une decision
         a la place du client.

         Jeremie a tranche le 24 aout: le « + » ouvre la rangee de tailles,
         toujours, et c'est le clic sur une taille qui ajoute.

         La memoire n'est pas perdue: la taille du client reste marquee d'un
         trait plein dans la rangee, donc son choix habituel se trouve du
         premier coup d'oeil. Elle informe, elle ne decide plus. */
      /* Une seule taille disponible : inutile de faire choisir, on ajoute. */
      if (data.v.length === 1 && live.length === 1) { add(live[0].id, btn, row, null); return; }
      var open = row.classList.toggle('is-open');
      btn.classList.toggle('is-open', open);
      /* Tant que la rangee est ouverte, le lien de la carte est desarme:
         sinon il capte les clics sur les tailles et ouvre la fiche produit.
         Voir le commentaire de `.fv-cat-choix` dans fv-catalog-pack.liquid. */
      var carte = btn.closest('.card-wrapper') || card;
      if (carte) carte.classList.toggle('fv-cat-choix', open);
      /* Le bouton ne dit plus « Pick a size » : la rangee de tailles qui vient
         de s'ouvrir le dit deja. Le « + » devient une croix, c'est-a-dire la
         sortie, le meme geste dans les deux sens. */
      if (open) say('×', 'Close the size picker for ' + title);
      else idle();
    });

  }

  var busy = false;
  function add(vid, btn, row, chip) {
    if (busy) return;
    busy = true;
    if (chip) chip.disabled = true;
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.j.description || 'unavailable');
        row.classList.remove('is-open');
        btn.classList.remove('is-open');
        /* Confirmation courte et muette : le client voit que c'est parti, et la
           barre du bas fait le reste du travail. Pas de pop-up qui recouvre le
           catalogue au moment precis ou on veut qu'il continue a le parcourir. */
        /* ── LA CONFIRMATION EST LE CHIFFRE QUI MONTE ──
           « + » devient « 1 », « 1 » devient « 2 ». Le geste se voit dans son
           resultat: il n'y a plus de coche a afficher puis a effacer.

           ⚠️ ON N'ECRIT PAS LE CHIFFRE A L'AVANCE. Une premiere version posait
           `auPanier() + 1` tout de suite, sans attendre la reponse du panier.
           Sur un panier qui venait d'etre vide ailleurs, le compteur local
           etait perime et le bouton affichait « 4 » pendant une seconde et
           demie avant de retomber a « 2 ». Un chiffre faux, meme une seconde,
           est pire qu'un chiffre en retard: c'est la quantite au panier, le
           client la croit.

           `is-done` n'est donc plus retire par un minuteur mais par la reponse
           elle-meme. Le vert dure exactement le temps de l'aller-retour, et
           `fvIdle()` ecrit ensuite la quantite REELLE, celle que Shopify
           vient de confirmer. */
        btn.classList.add('is-done');
        return refresh().then(function () {
          btn.classList.remove('is-done');
          if (btn.fvIdle) btn.fvIdle();
          else btn.fvSay('+', 'Add ' + btn.fvTitle + ' to your bag');
          document.dispatchEvent(new CustomEvent('cart:update'));
        });
      })
      .catch(function () {
        btn.classList.add('is-fail');
        btn.fvSay('!', btn.fvTitle + ' is unavailable in that size');
        setTimeout(function () {
          btn.classList.remove('is-fail');
          if (btn.fvIdle) btn.fvIdle();
          else btn.fvSay('+', 'Add ' + btn.fvTitle + ' to your bag');
        }, 1800);
      })
      .then(function () {
        busy = false;
        btn.disabled = false;
        if (chip) chip.disabled = false;
      });
  }

  /* Les filtres Dawn remplacent la grille entiere par du HTML neuf : sans cet
     observateur, les boutons disparaissent des qu'on trie par prix.
     Mais scan() ajoute lui-meme des noeuds dans la grille. On coupe donc
     l'observateur pendant qu'on ecrit, sinon il se declenche sur son propre
     travail et la page se fige. */
  var mo = null;
  function scan() {
    if (mo) mo.disconnect();
    document.querySelectorAll('.card-wrapper').forEach(build);
    badges();
    if (mo && grid) mo.observe(grid, { childList: true, subtree: true });
  }

  var grid = document.getElementById('ProductGridContainer');
  if (grid && window.MutationObserver) {
    var t = null;
    mo = new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(scan, 60);
    });
  }

  document.addEventListener('cart:update', function (e) {
    if (e.detail && e.detail.cart) readCart(e.detail.cart); else refresh();
  });

  /* La taille peut changer pendant la visite de cette page : un ajout depuis
     une autre carte l'ecrit. Toute la grille se realigne, sinon deux cartes
     voisines annonceraient deux tailles differentes. */
  document.addEventListener('fv:size', function () {
    document.querySelectorAll('.fv-cat-add').forEach(function (b) {
      if (b.fvSyncMine) b.fvSyncMine();
    });
  });

  scan();
  refresh();
}());
}
